import stateCheckin from './stateCheckin';
import mutations from './mutations';
import actions from './actions';

export default {
  state: stateCheckin,
  mutations,
  actions,
  namespaced: true
};
